module.exports = "<md-content class=dt-layout-content__container flex> <div layout=column flex> <div layout=column layout-align=\"top stretch\" layout-fill ui-view=content></div> </div> </md-content>";


//////////////////
// WEBPACK FOOTER
// ./app/common/content/content.html
// module id = vNKU
// module chunks = 1